/**
 * Shared utility for extracting instructions from template data
 */

interface ConnectionData {
  authentications?: {
    acctAuth?: {
      loginPrompt?: string;
    };
  };
}

/**
 * Extract instructions from ConnectionJSON loginPrompt field
 */
export const extractConnectionInstructions = (
  connectionJSON: string
): string => {
  try {
    const connectionData = JSON.parse(connectionJSON) as ConnectionData;
    const loginPrompt = connectionData.authentications?.acctAuth?.loginPrompt;

    return loginPrompt ? loginPrompt.trim() : '';
  } catch {
    return '';
  }
};

/**
 * Extract instructions from configInfo field in account operations
 */
export const extractAccountInstructions = (configInfo: string): string => {
  if (!configInfo || typeof configInfo !== 'string') {
    return '';
  }

  // Find text after ${connection.loginPrompt}, using multiline flag
  const match = configInfo.match(/\$\{connection\.loginPrompt\},\s*([\s\S]*)/);

  return match ? match[1].trim() : '';
};
